// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SpinTokens } from './type';

const spinTokens: SpinTokens = {
  spinTipFontColor: 'Brand-6',
  spinVerticalMargin: 'Margin-4',
  spinHorizontalMargin: 'Margin-4',
};

export default spinTokens;
